import React from 'react';
import { Routes, Route } from 'react-router-dom';

import VkCallbackPage from '../../../shared/pages/VkCallbackPage';

export default function PublicRouter({ children }) {
  return (
    <Routes>
      <Route path="/auth/vk-callback" element={<VkCallbackPage />} />
      <Route path="/*" element={children} />
    </Routes>
  );
}
